import * as faceapi from '@vladmandic/face-api';
import FaceDetectionModel from '../../models/FaceDetectionModel';
import jsonService from '../jsonService';

export default async function loadDetections(detections = [FaceDetectionModel()]) {
  return Promise.all(
    detections.map(async (detection) => {
      let _descriptions = jsonService.parse(detection.detection);
      return new faceapi.LabeledFaceDescriptors(detection.guestId, _descriptions);
    })
  );
}
